var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8 13.6V15.4C2.8 17.389 4.4119 19 6.4 19H15.4C17.389 19 19 17.389 19 15.4C19 12.4039 19 7.597 19 4.6C19 2.6119 17.389 1 15.4 1C12.8269 1 8.974 1 6.4 1C4.4119 1 2.8 2.6119 2.8 4.6V6.4C2.8 6.8968 3.2032 7.3 3.7 7.3C4.1968 7.3 4.6 6.8968 4.6 6.4C4.6 6.4 4.6 5.5567 4.6 4.6C4.6 3.6064 5.4064 2.8 6.4 2.8H15.4C16.3945 2.8 17.2 3.6064 17.2 4.6V15.4C17.2 16.3945 16.3945 17.2 15.4 17.2C12.8269 17.2 8.974 17.2 6.4 17.2C5.4064 17.2 4.6 16.3945 4.6 15.4C4.6 14.4442 4.6 13.6 4.6 13.6C4.6 13.1041 4.1968 12.7 3.7 12.7C3.2032 12.7 2.8 13.1041 2.8 13.6ZM9.6274 9.1L8.4637 7.93719C8.1127 7.58529 8.1127 7.0156 8.4637 6.6637C8.8156 6.3127 9.3853 6.3127 9.7363 6.6637L12.4363 9.3637C12.7882 9.7156 12.7882 10.2853 12.4363 10.6372L9.7363 13.3372C9.3853 13.6882 8.8156 13.6882 8.4637 13.3372C8.1127 12.9853 8.1127 12.4156 8.4637 12.0637L9.6274 10.9H1.9C1.4032 10.9 1 10.4968 1 10C1 9.5041 1.4032 9.1 1.9 9.1H9.6274Z",
    fill: "#3D444C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.705879a3cb85063d6960dc85f5dc7eb7.svg";
export { ForwardRef as ReactComponent };